import { useCallback } from 'react'

import filestack, { PickerDismissedError } from 'common/filestack'
import type { PickerFileMetadata, PickerOptions } from 'common/filestack'

const FILE_PICKER_CONFIG: PickerOptions = {
  maxFiles: 1,
  disableDirectoryUpload: true,
  accept: ['image/png', 'image/jpeg', 'image/pjpeg'],
  transformations: { crop: { aspectRatio: 1, force: true } },
  fromSources: ['local_file_system', 'url', 'webcam', 'facebook', 'googledrive', 'dropbox', 'instagram'],
  storeTo: {
    location: 's3',
    path: `/profile/`,
    access: 'private',
    container: window.FILE_STACK_BUCKET,
    region: 'us-east-1',
  },
}

export { PickerFileMetadata }

interface IUseImageUpload {
  onPickImage: (image: PickerFileMetadata) => void
}

export const useImageUpload = ({ onPickImage }: IUseImageUpload) => {
  const onChooseImage = useCallback(
    (e) => {
      e.stopPropagation()
      filestack
        .pickAndStore(FILE_PICKER_CONFIG)
        .then(([picked]): void => {
          return onPickImage(picked)
        })
        .catch((error) => {
          // Backing out of the picker is not an error worth reporting.
          if (error instanceof PickerDismissedError) {
            return
          }
          console.error('Error uploading image')
        })
    },
    [onPickImage],
  )

  return onChooseImage
}
